export const LOADING_VACCINES = 'LOADING_VACCINES';
export const GET_VACCINES = 'GET_VACCINES';
export const SAVE_LOADING_VACCINES = 'SAVE_LOADING_VACCINES';
export const FORM_FAIL = "FORM_FAIL";
export const VACCINES_FAIL = "VACCINES_FAIL";
